export default __webpack_public_path__ + "static/media/IMG-20240822-WA0003.863ef0c8.jpg";